import { track } from 'ripple';

export component DashboardPage(props) {
	let activeTab = track('overview');
	let onBack = props.onBack;
	let swaps = track([
		{id: 1, from: 'ETH', to: 'BTC', amount: '1.5', status: 'completed', date: '2025-01-15'},
		{id: 2, from: 'BTC', to: 'SOL', amount: '0.1', status: 'pending', date: '2025-01-14'},
		{id: 3, from: 'SOL', to: 'ETH', amount: '50', status: 'completed', date: '2025-01-13'}
	]);

	let balances = track([
		{token: 'ETH', balance: '2.5', value: '$4,500'},
		{token: 'BTC', balance: '0.5', value: '$30,000'},
		{token: 'SOL', balance: '100', value: '$2,000'},
		{token: 'USDC', balance: '1000', value: '$1,000'}
	]);

	<div class="dashboard-container">
		<aside class="sidebar">
			<div class="logo">{'CrossSwap'}</div>
			<nav class="nav-menu">
				<button class={@activeTab === 'overview' ? 'nav-item active' : 'nav-item'}
					onClick={() => @activeTab = 'overview'}>
					{"Overview"}
				</button>
				<button class={@activeTab === 'swaps' ? 'nav-item active' : 'nav-item'}
					onClick={() => @activeTab = 'swaps'}>
					{"Swaps"}
				</button>
				<button class={@activeTab === 'wallet' ? 'nav-item active' : 'nav-item'}
					onClick={() => @activeTab = 'wallet'}>
					{"Wallet"}
				</button>
				<button class={@activeTab === 'settings' ? 'nav-item active' : 'nav-item'}
					onClick={() => @activeTab = 'settings'}>
					{"Settings"}
				</button>
				<button class="nav-item" onClick={() => @onBack()}>
					{"Logout"}
				</button>
			</nav>
		</aside>

		<main class="main-content">
			<header class="dashboard-header">
				<h1>{"Dashboard"}</h1>
				<div class="user-info">
					<div class="user-avatar">{"U"}</div>
					<span>{"User Name"}</span>
				</div>
			</header>

			<div class="content-area">
				switch (@activeTab) {
					case 'overview':
						<div class="overview-section">
							<h2>{"Portfolio Overview"}</h2>
							<div class="portfolio-summary">
								<div class="summary-card">
									<h3>{"Total Value"}</h3>
									<p class="summary-amount">{"$37,500"}</p>
									<p class="summary-change positive">{"+5.2% (24h)"}</p>
								</div>
								<div class="summary-card">
									<h3>{"Active Swaps"}</h3>
									<p class="summary-amount">{"1"}</p>
									<p class="summary-change">{"In progress"}</p>
								</div>
								<div class="summary-card">
									<h3>{"Total Swaps"}</h3>
									<p class="summary-amount">{"12"}</p>
									<p class="summary-change">{"Completed"}</p>
								</div>
							</div>

							<div class="recent-swaps">
								<h3>{"Recent Swaps"}</h3>
								<div class="swaps-list">
									for (const swap of @swaps; key swap.id) {
										<div class="swap-item">
											<div class="swap-details">
												<span class="swap-amount">{swap.amount} {" "} {swap.from}</span>
												<span class="swap-arrow">{"→"}</span>
												<span class="swap-amount">{swap.to}</span>
											</div>
											<div class="swap-status">{swap.status}</div>
											<div class="swap-date">{swap.date}</div>
										</div>
									}
								</div>
							</div>
						</div>
						break;
					case 'swaps':
						<div class="swaps-section">
							<div class="section-header">
								<h2>{"Swaps"}</h2>
								<button class="btn btn-primary">{"New Swap"}</button>
							</div>
							<div class="swaps-list">
								for (const swap of @swaps; key swap.id) {
									<div class="swap-card">
										<div class="swap-header">
											<div class="swap-pair">
												{swap.amount} {" "} {swap.from} {"→"} {swap.to}
											</div>
											<div class={"swap-status " + swap.status}>
												{swap.status}
											</div>
										</div>
										<div class="swap-info">
											<div>{"Date: " + swap.date}</div>
											<div>{"Swap ID: #" + swap.id}</div>
										</div>
									</div>
								}
							</div>
						</div>
						break;
					case 'wallet':
						<div class="wallet-section">
							<div class="section-header">
								<h2>{"Wallet"}</h2>
								<button class="btn btn-primary">{"Deposit"}</button>
							</div>
							<div class="balances-list">
								for (const balance of @balances; key balance.token) {
									<div class="balance-item">
										<div class="balance-token">{balance.token}</div>
										<div class="balance-amount">{balance.balance}</div>
										<div class="balance-value">{balance.value}</div>
									</div>
								}
							</div>
						</div>
						break;
					case 'settings':
						<div class="settings-section">
							<h2>{"Settings"}</h2>
							<div class="settings-form">
								<div class="form-group">
									<label>{"Username"}</label>
									<input type="text" value="username" class="form-input" />
								</div>
								<div class="form-group">
									<label>{"Email"}</label>
									<input type="email" value="user@example.com" class="form-input" />
								</div>
								<button class="btn btn-primary">{"Save Settings"}</button>
							</div>
						</div>
						break;
				}
			</div>
		</main>
	</div>

	<style>
		.dashboard-container {
			display: flex;
			min-height: 100vh;
			font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
			background-color: #f8fafc;
		}

		.sidebar {
			width: 250px;
			background: white;
			border-right: 1px solid #e5e7eb;
			padding: 1.5rem 1rem;
			height: 100vh;
			position: fixed;
		}

		.logo {
			font-size: 1.5rem;
			font-weight: bold;
			color: #4f46e5;
			margin-bottom: 2rem;
			text-align: center;
		}

		.nav-menu {
			display: flex;
			flex-direction: column;
			gap: 0.5rem;
		}

		.nav-item {
			background: none;
			border: none;
			padding: 0.75rem 1rem;
			text-align: left;
			cursor: pointer;
			border-radius: 0.5rem;
			transition: all 0.3s ease;
			color: #6b7280;
		}

		.nav-item:hover, .nav-item.active {
			background: #eef2ff;
			color: #4f46e5;
		}

		.main-content {
			flex: 1;
			margin-left: 250px;
			padding: 2rem;
		}

		.dashboard-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 2rem;
		}

		.dashboard-header h1 {
			font-size: 1.75rem;
			color: #1f2937;
		}

		.user-info {
			display: flex;
			align-items: center;
			gap: 0.75rem;
		}

		.user-avatar {
			width: 40px;
			height: 40px;
			border-radius: 50%;
			background: #4f46e5;
			color: white;
			display: flex;
			align-items: center;
			justify-content: center;
			font-weight: bold;
		}

		.content-area {
			background: white;
			border-radius: 1rem;
			padding: 2rem;
			box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
		}

		.section-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 1.5rem;
		}

		.section-header h2 {
			font-size: 1.5rem;
			color: #1f2937;
		}

		.portfolio-summary {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
			gap: 1.5rem;
			margin-bottom: 2rem;
		}

		.summary-card {
			background: #f8fafc;
			padding: 1.5rem;
			border-radius: 0.75rem;
			text-align: center;
		}

		.summary-card h3 {
			color: #6b7280;
			font-size: 0.875rem;
			margin-bottom: 0.5rem;
		}

		.summary-amount {
			font-size: 1.5rem;
			font-weight: bold;
			color: #1f2937;
			margin-bottom: 0.25rem;
		}

		.summary-change {
			font-size: 0.875rem;
			color: #10b981;
		}

		.summary-change.positive {
			color: #10b981;
		}

		.summary-change.negative {
			color: #ef4444;
		}

		.recent-swaps h3, .swaps-section h2, .wallet-section h2, .settings-section h2 {
			margin-bottom: 1rem;
			color: #1f2937;
		}

		.swaps-list {
			display: flex;
			flex-direction: column;
			gap: 1rem;
		}

		.swap-item, .swap-card {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 1rem;
			border: 1px solid #e5e7eb;
			border-radius: 0.5rem;
			background: #f9fafb;
		}

		.swap-card {
			flex-direction: column;
			align-items: flex-start;
			gap: 0.5rem;
		}

		.swap-header {
			display: flex;
			justify-content: space-between;
			width: 100%;
			align-items: center;
		}

		.swap-pair {
			font-weight: bold;
			color: #1f2937;
		}

		.swap-status {
			padding: 0.25rem 0.75rem;
			border-radius: 9999px;
			font-size: 0.75rem;
			font-weight: 500;
		}

		.swap-status.completed {
			background: #d1fae5;
			color: #065f46;
		}

		.swap-status.pending {
			background: #fef3c7;
			color: #92400e;
		}

		.balances-list {
			display: flex;
			flex-direction: column;
			gap: 1rem;
		}

		.balance-item {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 1rem;
			border: 1px solid #e5e7eb;
			border-radius: 0.5rem;
		}

		.balance-token {
			font-weight: bold;
			color: #1f2937;
		}

		.balance-amount {
			color: #6b7280;
		}

		.balance-value {
			font-weight: bold;
			color: #1f2937;
		}

		.settings-form {
			max-width: 400px;
		}

		.form-group {
			margin-bottom: 1rem;
		}

		.form-group label {
			display: block;
			margin-bottom: 0.5rem;
			color: #374151;
			font-weight: 500;
		}

		.form-input {
			width: 100%;
			padding: 0.75rem;
			border: 1px solid #d1d5db;
			border-radius: 0.5rem;
			font-size: 1rem;
		}

		.form-input:focus {
			outline: none;
			border-color: #4f46e5;
			box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
		}

		.btn {
			padding: 0.75rem 1.5rem;
			border: none;
			border-radius: 0.5rem;
			cursor: pointer;
			font-size: 1rem;
			transition: all 0.3s ease;
		}

		.btn-primary {
			background: #4f46e5;
			color: white;
		}

		.btn-primary:hover {
			background: #4338ca;
		}
	</style>
}
